import gql from 'graphql-tag';

import { vehicleAssemblyFields } from './my-account-queries';

export const ACTIVATE_ACCOUNT = gql`
  mutation activateAccount($token: String!) {
    account {
      activateAccount(token: $token)
    }
  }
`;

export const DELETE_ADDRESS = gql`
  mutation deleteAddress($contactType: ContactEnum!) {
    account {
      deleteAddress(contactType: $contactType)
    }
  }
`;

export const SIGN_UP = gql`
  mutation signUp($input: RegistrationInput!, $storeCode: String!) {
    account {
      signUp(input: $input, storeCode: $storeCode)
    }
  }
`;

export const SIGN_IN = gql`
  mutation signIn($input: SignInInput!, $storeCode: String!) {
    account {
      signIn(input: $input, storeCode: $storeCode) {
        accountLocked
        authenticated
        disabled
        customerData {
          uid
          displayUid
          customerId
          name
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($emailId: String!, $storeCode: String!) {
    account {
      resetPassword(emailId: $emailId, storeCode: $storeCode)
    }
  }
`;

export const UPDATE_SAVED_VEHICLE = gql`
  mutation updateSavedVehicle($vehicle: SavedVehicleInput!) {
    account {
      updateSavedVehicle(vehicle: $vehicle) {
        code
        isActive
        isOE
        sizeQualifier
        frontTireSize
        rearWheelRimDiameter
        frontWheelRimDiameter
        rearTireSize
        savedDate
        vehicleAssembly {
          ...vehicleAssemblyFields
        }
      }
    }
  }
  ${vehicleAssemblyFields}
`;

export const UPDATE_PASSWORD = gql`
  mutation updatePassword(
    $newPassword: PasswordType!
    $currentPassword: PasswordType!
  ) {
    account {
      updatePassword(
        newPassword: $newPassword
        currentPassword: $currentPassword
      )
    }
  }
`;

export const UPDATE_PRIMARY_ADDRESS = gql`
  mutation updatePrimaryAddress($primaryAddressInput: PrimaryAddressInput!) {
    account {
      updatePrimaryAddress(primaryAddressInput: $primaryAddressInput)
    }
  }
`;

export const UPDATE_SECONDARY_ADDRESS = gql`
  mutation updateSecondaryAddress(
    $secondaryAddressInput: SecondaryAddressInput!
  ) {
    account {
      updateSecondaryAddress(secondaryAddressInput: $secondaryAddressInput)
    }
  }
`;

export const DELETE_SAVED_VEHICLE = gql`
  mutation deleteSavedVehicle($savedVehicleId: String!) {
    account {
      deleteSavedVehicle(savedVehicleId: $savedVehicleId)
    }
  }
`;

export const SIGN_OUT = gql`
  mutation signOut {
    account {
      signOut
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($password: String!, $token: String!) {
    account {
      forgotPassword(password: $password, token: $token)
    }
  }
`;

export const SET_ACTIVE_STATUS_SAVED_VEHICLE = gql`
  mutation setActiveStatusSavedVehicle(
    $savedVehicleId: String!
    $isActive: Boolean!
  ) {
    account {
      activeSavedVehicle(savedVehicleId: $savedVehicleId, isActive: $isActive)
    }
  }
`;

export const UPDATE_RECENT_VEHICLES = gql`
  mutation updateRecentVehicles($vehicles: [SearchVehicleInput]!) {
    account {
      searchVehicles(vehicles: $vehicles) {
        vehicleAssembly {
          vehicleAssemblyID
        }
      }
    }
  }
`;

export const REGISTER_GUEST_CHECKOUT_USER = gql`
  mutation registerGuestCheckoutUser(
    $registerGuestUserInput: RegisterGuestUserInput!
  ) {
    account {
      registerGuestCheckoutUser(registerGuestUserInput: $registerGuestUserInput)
    }
  }
`;

export const UPDATE_EMAIL = gql`
  mutation updateEmail($token: String!) {
    account {
      updateEmail(token: $token)
    }
  }
`;

export const SEND_AUTHENTICATION_EMAIL = gql`
  mutation sendAuthenticationEmail($emailId: String!, $storeCode: String!) {
    account {
      sendAuthenticationEmail(emailId: $emailId, storeCode: $storeCode)
    }
  }
`;
